import $ from 'jquery';

export const convertPromiseToDeferred = p => {
	const defer = $.Deferred();
	p.then(function () {
		defer.resolve.apply(defer, arguments);
	}, function (err) {
		defer.reject.apply(defer, arguments);
	});
	return defer.promise();
};